/**
 * Stepper — Pasek postępu wizarda (1 → 2 → 3 → 4).
 *
 * Props:
 *   - currentStep (number)         — aktywny krok (1-4)
 *   - completedSteps (Set<number>) — kroki ukończone (otrzymują check)
 *   - onStepClick (callback)       — opcjonalne: klik na numer pozwala wrócić
 */
import { Check } from "lucide-react";

const STEPS = [
  { num: 1, label: "Podmiot" },
  { num: 2, label: "Certyfikat" },
  { num: 3, label: "Test" },
  { num: 4, label: "Gotowe" },
];

export const Stepper = ({ currentStep, completedSteps, onStepClick }) => {
  return (
    <div className="w-full" data-testid="wizard-stepper">
      <div className="flex items-center justify-between">
        {STEPS.map((step, idx) => {
          const isActive = step.num === currentStep;
          const isCompleted = completedSteps.has(step.num);
          const isClickable = onStepClick && (isCompleted || step.num < currentStep);

          return (
            <div key={step.num} className="flex items-center flex-1 last:flex-none">
              {/* Circle */}
              <button
                type="button"
                disabled={!isClickable}
                onClick={() => isClickable && onStepClick(step.num)}
                className={`flex flex-col items-center gap-2 transition-colors ${
                  isClickable ? "cursor-pointer hover:opacity-80" : "cursor-default"
                }`}
                data-testid={`stepper-step-${step.num}`}
              >
                <div
                  className={`w-9 h-9 rounded-full flex items-center justify-center font-medium text-sm border-2 transition-all ${
                    isActive
                      ? "bg-blue-600 text-white border-blue-600 shadow-md"
                      : isCompleted
                      ? "bg-green-500 text-white border-green-500"
                      : "bg-white text-gray-400 border-gray-300"
                  }`}
                >
                  {isCompleted && !isActive ? <Check className="w-4 h-4" /> : step.num}
                </div>
                <span
                  className={`text-xs font-medium hidden sm:block ${
                    isActive
                      ? "text-blue-700"
                      : isCompleted
                      ? "text-green-700"
                      : "text-gray-400"
                  }`}
                >
                  {step.label}
                </span>
              </button>

              {/* Connector */}
              {idx < STEPS.length - 1 && (
                <div className="flex-1 h-0.5 mx-2 mb-5 sm:mb-7 bg-gray-200 relative">
                  <div
                    className={`absolute inset-0 transition-all duration-300 ${
                      completedSteps.has(step.num) ? "bg-green-500" : "bg-gray-200"
                    }`}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Mobile-only active label */}
      <div className="mt-3 text-center sm:hidden">
        <span className="text-sm font-medium text-blue-700">
          Krok {currentStep} z 4: {STEPS[currentStep - 1]?.label}
        </span>
      </div>
    </div>
  );
};

export default Stepper;
